import clsx from '@/lib/clsx';

const WizardQuestionBlock = ({ title, children, className = '', titleClassName = '', ...props }) => {
  return (
    <div className={clsx('comp-wizard-question-block', className)} {...props}>
      {title && <div className={clsx('comp-wizard-question-title', titleClassName)}>{title}</div>}
      {children}
    </div>
  );
};

export default WizardQuestionBlock;
